import { useState } from "react";
import { Form, Input, Button } from "antd";
import styled from "styled-components";
import COLORS from "../../common/Colors";
import { useDispatch } from "react-redux";
import { setIsLoggedIn, setUserInfo } from "../../Redux/AuthSlice";
import { useNavigate } from "react-router-dom";
import logo from "../../assets/Images/Frame 45.png";
import { loginUser } from "../../Services/auth";
import Cookies from "js-cookie";

const DivContainer = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #3c4173;
  background: linear-gradient(
    90deg,
    rgba(60, 65, 115, 1) 0%,
    rgba(66, 141, 199, 1) 100%
  );
  overflow: hidden; /* Prevent scrollbar */
`;

const StyledContainer = styled.div`
  width: 400px;
  margin: auto;
  padding: 24px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0px 3px 6px #00000029;
`;

const StyledCenterAlign = styled.h3`
  text-align: center;
  font-size: 1.4rem;
  padding-bottom: 20px;
  padding-top: 10px;
  font-weight: 600;
`;

const StyledCenterAlignLogo = styled.div`
  display: flex;
  justify-content: center;
`;

const StyledForm = styled(Form)`
  .ant-form-item-label > label {
    color: ${COLORS.text.white};
  }

  .ant-form-item {
    text-align: justify;
    margin-bottom: 2rem !important;
    .ant-form-item-control-input-content {
      input {
        border-radius: 12px;
        height: 50px;
        padding-left: 16px;
        color: ${COLORS.text.primary};
        font-size: 1rem;
        font-weight: 600;
      }

      .ant-input-affix-wrapper.ant-input-password {
        border-radius: 12px;
        padding: 0px;
        input {
          border: none;
        }
      }

      .ant-form-item-with-help .ant-form-item-explain {
        text-align: justify;
      }

      .ant-input-suffix {
        padding: 0px 8px 0px 8px;
        margin: 0px;
      }
    }
  }
`;

const StyleSubmitButton = styled(Button)`
  font-weight: bold;
  height: 60px;
  border-radius: 12px;
  width: 100%;
`;

const Login = () => {
  const [loginForm] = Form.useForm();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [attemptMessage, setAttemptMessage] = useState("");
  const navigate = useNavigate();

  // Updated LoginFn to handle form values and make the API call
  const LoginFn = async (values) => {
    setLoading(true);

    try {
      let payload = {
        email: values?.userId,
        password: values?.password,
      };

      const response = await loginUser(payload);

      if (response && response.token) {
        const expireTime = new Date(response.expire_at).getTime(); // Convert to milliseconds
        const now = new Date().getTime();
        const expiresInMinutes = (expireTime - now) / (1000 * 60); // Convert to minutes

        const isHttps = window.location.protocol === "https:";

        Cookies.set("authToken", response.token, {
          expires: expiresInMinutes / (60 * 24),
          secure: isHttps, // Secure only for HTTPS
          sameSite: isHttps ? "None" : "Lax", // None for HTTPS, Lax for HTTP
        });

        Cookies.set("isLoggedIn", "true", {
          expires: expiresInMinutes / (60 * 24),
          secure: isHttps,
          sameSite: isHttps ? "None" : "Lax",
        });

        // Dispatch Redux action to update login state
        dispatch(setIsLoggedIn(true));
        dispatch(setUserInfo({ name: response?.name }));

        // Navigate to the user list page
        // navigate("/userList");
        navigate("/dashboard");
      } else if (response && response.is_admin_two_factor){
        navigate("/authentication", {
          state: {
            temp_token: response.temp_token,
          },
        });
      } else if (response && response.is_failed){
        setAttemptMessage(response.attempt_message);
          // setTimeout(() => {
          //   setAttemptMessage("");
          // }, 15000);
      }
    } catch (error) {
      console.error("Login failed:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <DivContainer>
      <StyledContainer>
        <StyledCenterAlignLogo>
          <img src={logo} alt="logo" />
        </StyledCenterAlignLogo>

        <StyledCenterAlign>Login to your account</StyledCenterAlign>

        <StyledForm
          layout="vertical"
          name="basic"
          form={loginForm}
          initialValues={{
            userId: "",
            password: "",
          }}
          onFinish={LoginFn}
        >
          <Form.Item
            name="userId"
            required
            rules={[
              {
                required: true,
                message: "Please enter Email",
              },
            ]}
          >
            <Input placeholder="Email" />
          </Form.Item>

          <Form.Item
            name="password"
            required
            rules={[
              {
                required: true,
                message: "Please enter Password",
              },
            ]}
          >
            <Input.Password placeholder="Password" />
          </Form.Item>
          
          {attemptMessage && (
            <div style={{textAlign:'start', marginTop: '-23px', marginBottom:'10px', fontSize:'12px'}}><b>Note:</b> {attemptMessage}</div>
          )}
          
          <StyleSubmitButton type="primary" htmlType="submit" loading={loading}>
            Log In
          </StyleSubmitButton>
        </StyledForm>
      </StyledContainer>
    </DivContainer>
  );
};

export default Login;
